import { type ClassValue, clsx } from "clsx";
import { type VariantProps, cva } from "cva";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

type RowVProps = VariantProps<typeof labelledRowVariants>;
export type LabelledRowVariant = RowVProps["variant"];
export const labelledRowVariants = cva({
	base: "",
	variants: {
		variant: {
			default: "text-gray-500 text-sm md:text-base",
			crm: "text-gray-700 text-sm",
		},
	},
	defaultVariants: {
		variant: "default",
	},
});
